angular.module('main').factory('Reducers::Root', [
  'Reducers::Common',
  'Reducers::TaskManagementRoot',
  'Reducers::ExamManagementRoot',
  function (
    CommonReducer,
    TaskManagementReducer,
    ExamManagementReducer
  ) {
    function reducer(state, action) {
      state = state || {};
      state = CommonReducer(state, action);
      state = TaskManagementReducer(state, action);
      state = ExamManagementReducer(state, action);
      return state;
    }

    return reducer;
  }
]);
